var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscountTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.373 5.373 0 12 0C18.624 0.008 23.992 5.376 24 12C24 18.627 18.627 24 12 24C5.373 24 0 18.627 0 12Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.373 0 0 5.373 0 12C0 18.627 5.373 24 12 24C18.627 24 24 18.627 24 12C23.992 5.376 18.624 0.008 12 0ZM18.927 8.2L12.082 17.489C11.746 17.935 11.112 18.024 10.666 17.688C10.661 17.684 10.657 17.681 10.652 17.677L5.764 13.769C5.333 13.424 5.263 12.794 5.608 12.363C5.953 11.932 6.583 11.862 7.014 12.207L11.09 15.468L17.317 7.017C17.623 6.557 18.244 6.433 18.704 6.739C19.164 7.045 19.288 7.666 18.982 8.126C18.964 8.152 18.946 8.176 18.927 8.2Z",
    fill: "#52B57A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountTick);
export default __webpack_public_path__ + "static/media/discount-tick.5300b8306cdf22da5df27cee203706b5.svg";
export { ForwardRef as ReactComponent };